import { render } from "./ExpenditureStatisticsList.vue?vue&type=template&id=7c62951c"
import script from "./ExpenditureStatisticsList.vue?vue&type=script&lang=js"
export * from "./ExpenditureStatisticsList.vue?vue&type=script&lang=js"

import "./ExpenditureStatisticsList.vue?vue&type=style&index=0&id=7c62951c&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__